import { useState } from "react";
import { Navigate } from "react-router-dom";
import { toast } from "sonner";
import { Lock } from "lucide-react";

const AUTH_KEY = "mocktpAdminAuth";

export default function AdminEntry() {
  const [credentials, setCredentials] = useState({ username: "", password: "" });
  const [authToken, setAuthToken] = useState(() => sessionStorage.getItem(AUTH_KEY) || "");

  const login = (event) => {
    event.preventDefault();
    if (!credentials.username.trim() || !credentials.password) {
      toast.error("Enter the admin username and password.");
      return;
    }
    const token = btoa(`${credentials.username.trim()}:${credentials.password}`);
    sessionStorage.setItem(AUTH_KEY, token);
    setAuthToken(token);
    setCredentials({ username: "", password: "" });
  };

  if (authToken) {
    return <Navigate to="/admin/beta-applications" replace />;
  }

  return (
    <main className="min-h-screen bg-[#080C16] text-white flex items-center justify-center px-6">
      <form
        onSubmit={login}
        className="w-full max-w-sm rounded-2xl border border-white/10 bg-white/[0.03] p-6 shadow-2xl"
      >
        <div className="flex items-center gap-3 mb-6">
          <div className="h-11 w-11 rounded-xl bg-[#00DC82] text-[#080C16] flex items-center justify-center">
            <Lock size={22} />
          </div>
          <div>
            <h1 className="text-xl font-semibold tracking-tight">MockTP Admin</h1>
            <p className="text-sm text-slate-400">MockTP internal dashboard</p>
          </div>
        </div>
        <label className="block text-sm text-slate-300 mb-2" htmlFor="admin-username">
          Username
        </label>
        <input
          id="admin-username"
          value={credentials.username}
          onChange={(event) => setCredentials((current) => ({ ...current, username: event.target.value }))}
          className="mb-4 h-11 w-full rounded-xl border border-white/10 bg-white/[0.04] px-4 text-sm outline-none focus:border-[#00DC82]"
        />
        <label className="block text-sm text-slate-300 mb-2" htmlFor="admin-password">
          Password
        </label>
        <input
          id="admin-password"
          type="password"
          value={credentials.password}
          onChange={(event) => setCredentials((current) => ({ ...current, password: event.target.value }))}
          className="mb-6 h-11 w-full rounded-xl border border-white/10 bg-white/[0.04] px-4 text-sm outline-none focus:border-[#00DC82]"
        />
        <button className="h-11 w-full rounded-full bg-[#00DC82] text-[#080C16] font-semibold hover:bg-[#00B86B] transition-colors">
          Sign in
        </button>
      </form>
    </main>
  );
}
